/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkImportFacilityServiceAreasResponseErrorsInner } from './BulkImportFacilityServiceAreasResponseErrorsInner';
import {
    BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON,
    BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped,
    BulkImportFacilityServiceAreasResponseErrorsInnerToJSON,
    BulkImportFacilityServiceAreasResponseErrorsInnerToJSONTyped,
} from './BulkImportFacilityServiceAreasResponseErrorsInner';

/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasResponse
 */
export interface BulkImportFacilityServiceAreasResponse {
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    succeeded: number;
    /**
     * 
     */
    failed: number;
    /**
     * 
     */
    errors: Array<BulkImportFacilityServiceAreasResponseErrorsInner>;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkImportFacilityServiceAreasResponse(value: object): value is BulkImportFacilityServiceAreasResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function BulkImportFacilityServiceAreasResponseFromJSON(json: any): BulkImportFacilityServiceAreasResponse {
    return BulkImportFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'succeeded': json['succeeded'],
        'failed': json['failed'],
        'errors': ((json['errors'] as Array<any>).map(BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON)),
    };
}

export function BulkImportFacilityServiceAreasResponseToJSON(json: any): BulkImportFacilityServiceAreasResponse {
    return BulkImportFacilityServiceAreasResponseToJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseToJSONTyped(value?: BulkImportFacilityServiceAreasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'succeeded': value['succeeded'],
        'failed': value['failed'],
        'errors': ((value['errors'] as Array<any>).map(BulkImportFacilityServiceAreasResponseErrorsInnerToJSON)),
    };
}

